export const VideoIntroducePageRouting = {
  path: "/train/VideoIntroducePage",
  name: "VideoIntroducePage",
  meta: { title: "视频介绍" },
  component: () => import(/* webpackChunkName: "login" */ "@/views/VideoIntroducePage/index.vue"),
};
